import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

// You should add these CSS rules to your project's stylesheet (e.g., index.css)
/*
.video-responsive-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; 
}

.video-responsive-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}
*/

const HMRCVisitPreparation = () => {
  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  const title = "1. Legal insights on buying or leasing commercial property.";

  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>
        Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers | MSB
        </title>
        <meta name="description" content="" />
        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers | MSB"
        />
        <meta property="og:description" content="" />
        <meta property="og:type" content="website" />
        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
        ================================================== */}
        <section
          id="overview"
          className="page_header text-center section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <h1 className="page_title text-white">
              HMRC Visit Preparation - Stay Compliant & Inspection Ready
            </h1>
            {/* <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n")
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1> */}
            <ul className="breadcrumb_nav unordered_list justify-content-center d-none">
              <li>
                <NavLink to="/webinars">Webinars</NavLink>
              </li>
              <li className="active">
                <a href="#!">
                 
                </a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
        ================================================== */}
        {/* Contact Section - Start
        ================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              <div className="d-flex justify-content-end mb-3">
                <NavLink to="/webinars" className="btn bg-primary text-dark">
                  ← Back
                </NavLink>
              </div>
              <img
                className="rounded-2 mb-5"
                src="assets/images/webinars/hmrc-visit-preparation.png"
                alt="Legal insights on buying or leasing commercial property and Sponsoring overseas skilled workers"
              />
              {/* <h4>Title</h4> */}
              <p className="mb-5">
              On 13th March, attendees from across the MSB industry joined an insightful session led by <strong>Mr. Ajinkya Patil, Compliance Manager at Calyx Solutions</strong>, focusing on how to effectively prepare for HMRC compliance visits. Ajinkya covered the key reasons why HMRC conducts inspections, common triggers, and the essential records and systems businesses must maintain. He also shared practical guidance on how to prepare your premises and staff, what to expect during a visit, and how to respond to HMRC findings.

              </p>
              

              <div className="item_details_content p-3">
                <div className="row mb-5">
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/date.svg"
                        alt="Date"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Date</h5>
                        <span>Thursday 13 Mar, 2026</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/time.svg"
                        alt="Time"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Time</h5>
                        <span>1 PM GMT</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/platform.svg"
                        alt="Platform"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Platform</h5>
                        <span>Google Meet</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/attendance.svg"
                        alt="Attendance"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Attendance</h5>
                        <span>100+ Attendees</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-baseline">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                     Understanding HMRC Inspections
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>Why HMRC conducts compliance visits</li>
                          <li>Common triggers for inspections</li>
                          
                       
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                    Documentation & Compliance Readiness
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>Key records and systems you must maintain</li>
                          <li>Ensuring your documentation meets HMRC expectations</li>
                         
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-baseline">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                     Preparing for the Visit
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>How to prepare your premises and staff</li>
                          <li>What HMRC officers typically check</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                     During & After the Visit
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>What happens during an inspection</li>
                          <li>Post-visit actions and responding to HMRC findings</li>
                          <li>Practical steps to reduce compliance risk</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-center">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                     What Made It Stand Out
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>Practical, compliance-focused guidance from <strong>Ajinkya Patil</strong>.</li>
                          <li>Real-life scenarios relevant to MSBs.</li>
                          <li>Clear and simple explanation of HMRC expectations.</li>
                          <li>Interactive Q&A with actionable takeaways.</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <hr className="d-block d-sm-none" />

                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="video-responsive-wrapper">
                      <iframe
                        src="https://www.youtube.com/embed/WCF_Uyq2KOs"
                        title="Skilled Worker Sponsorship Licence Guide + Property Leasing Tips, Expert Session by Lumine Solicitors"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HMRCVisitPreparation;
